module.exports = __webpack_public_path__ + "static/media/englishopoly.c07233cd.png";